import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {LocalStorage} from "@/common/storage.ts";
import {Select} from "antd";
import {LANGUAGE_OPTION} from "@/constant/constants.ts";

export const SwitchLangButton = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    const handleChange = (value: string) => {
        LocalStorage.setLang(value);
        navigate(0);
    }

    return (
        <>
            <div className={"mr-2"}>
                <Select
                    value={LocalStorage.getLang() || LANGUAGE_OPTION.ENGLISH}
                    style={{width: 90}}
                    variant="borderless"
                    onChange={handleChange}
                    options={[
                        {value: LANGUAGE_OPTION.JAPAN, label: t('field.japanese')},
                        {value: LANGUAGE_OPTION.ENGLISH, label: t('field.english')}
                    ]}
                />
            </div>
        </>
    )
}